let token = "";
let uuid = "";
let options = "";

const setOptions = (o) => {
  if (options !== "") return;
  options = o;
};
const getOptions = () => options;
const setUUID = (u) => {
  if (u && u !== "") {
    uuid = u;
    try {
      localStorage.setItem("uuid", uuid);
    } catch (e) {
      console.error("save token error", e);
    }
    return uuid;
  }
};
const getUUID = () => {
  if (uuid) return uuid;
  try {
    const uuid = localStorage.getItem("uuid");
    if (uuid) token = uuid;
    return token;
  } catch (e) {
    console.error(e);
  }
  // if (uuid) {
  //   uuid = localStorage.getItem('token');
  // }
  // return uuid;
};
const saveToken = (t) => {
  token = t;
  try {
    localStorage.removeItem("token");
    localStorage.setItem("token", t);
  } catch (e) {
    console.error("save token error", e);
  }
};

const getToken = () => {
  if (token) return token;
  try {
    const saveToken = localStorage.getItem("token");
    if (saveToken) token = saveToken;
    return token;
  } catch (e) {
    console.error(e);
  }
};

const clear = () => {
  token = "";
  uuid = '';
  try {
    localStorage.setItem("token", '');
    localStorage.setItem("uuid", '');
  } catch (e) {
    console.error(e);
  }
};

export default {
  saveToken,
  getToken,
  clear,
  setUUID,
  getUUID,
  getOptions,
  setOptions,
};
